<div class="row form-property  {{property?.styleClass ? property.styleClass : ''}}">
  <div
    class="col-lg-{{tooltip?10:12}}"
    [ngClass]="{'no-padding-right':tooltip}"
  >
    <span class="p-float-label">
      <p-autoComplete #filterInput
                      id="{{name}}"
                      [suggestions]="suggestions$ | async"
                      (onSelect)="select($event)"
                      [(ngModel)]="value"
                      [field]="field"                
                      [readonly]="readonly"
                      [ngClass]="{'disabled':readonly, 'autocomplete-property-invalid':notValid}"          
                      [inputStyle]="{'width': 'inherit','margin-right': '-34px'}"
                      [style]="{'width': '100%'}"                      
                      (onBlur)="onBlur($event)"
                      (ngModelChange)="changeAutocomplete($event)">
        <ng-template let-slctd pTemplate="selectedItem">
          <span style="vertical-align: initial">{{ slctd.FirstName + ' ' + slctd.LastName + ' | Username: '+slctd.UserName +' | Code: '+ slctd.Code }}</span>
        </ng-template>
        <ng-template let-opt pTemplate="item">
          <div>{{ opt.FirstName + ' ' + opt.LastName + ' | Role(s): '+opt.Roles }}</div>
          <div>{{ 'Username: '+ opt.UserName +' | Code: '+ opt.Code }}</div>
          <div>{{ 'Email: '+ (opt.Email ? opt.Email:'/') + ' | Phone: '+ (opt.PhoneNumber? opt.PhoneNumber:'/') }}</div>
          <div>{{ 'Company group(s): ' + (opt.CompanyGroups?opt.CompanyGroups:'/') }}</div>
        </ng-template>
      </p-autoComplete>
      <label class="gs-float-label {{property?.labelClass ? property.labelClass : ''}}" [ngClass]="{'error-color':notValid}"
        >{{label}}</label
      >
      <span
        *ngIf="notValid"
        class="form-error"
        pTooltip="{{property.validationMessage}}"
        tooltipPosition="top"
      >
        <i
          class="fas fa-info-circle fa-2x form-valid-icon with-icon error-color"
        ></i>
      </span>
    </span>
  </div>
  <div *ngIf="tooltip" class="col-lg-2 property-tooltip">
    <span pTooltip="{{property.tooltip}}">
      <i class="fas fa-info-circle master-color"></i>
    </span>
  </div>
</div>
